import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Lock, CheckCircle, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export const PaywallPanel = () => (
  <Card className="border-blue-500/30 overflow-hidden" data-testid="paywall-panel"
    style={{ background: 'linear-gradient(180deg, rgba(59,130,246,0.08) 0%, rgba(10,10,10,0) 100%)' }}>
    <CardContent className="p-8 sm:p-10 text-center">
      <div className="w-14 h-14 rounded-full bg-blue-600/15 flex items-center justify-center mx-auto mb-5">
        <Lock className="w-7 h-7 text-blue-400" />
      </div>
      <h3 className="font-heading text-xl sm:text-2xl font-bold text-white mb-2">Unlock Full Report + Action Plan</h3>
      <p className="text-zinc-400 text-sm mb-8 max-w-md mx-auto">
        Get detailed recommendations, exact pages to fix, and competitor benchmarking.
      </p>

      <div className="text-left max-w-sm mx-auto space-y-3 mb-8">
        {[
          "10 prioritized actions with exact pages",
          "Detailed fix recommendations for every issue",
          "Competitor benchmarking (up to 3)",
          "Full issue breakdown with affected URLs",
          "Recommended new pages to create"
        ].map((item, i) => (
          <div key={i} className="flex items-center gap-3">
            <CheckCircle className="w-4 h-4 text-blue-400 shrink-0" />
            <span className="text-sm text-zinc-300">{item}</span>
          </div>
        ))}
      </div>

      <Link to="/pricing" data-testid="unlock-report-btn">
        <Button className="bg-blue-600 hover:bg-blue-500 text-white font-bold py-4 px-8 rounded-sm shadow-[0_0_15px_rgba(59,130,246,0.4)] text-base">
          Unlock full report <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      </Link>

      <Link to="/full-audit" className="block mt-5 text-zinc-500 text-sm hover:text-zinc-400 transition-colors" data-testid="run-another-baseline">
        Run another audit
      </Link>
    </CardContent>
  </Card>
);
